import React, { useEffect, useState, useRef, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface BookingModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function BookingModal({
  isOpen,
  onClose
}: BookingModalProps) {
  const [llegada, setLlegada] = useState('');
  const [salida, setSalida] = useState('');
  const [personas, setPersonas] = useState('');
  const [nombre, setNombre] = useState('');
  const [error, setError] = useState('');
  useEffect(() => {
    ;
    (window as any).enviarWhatsApp = function () {
      const llegadaVal = (document.getElementById('llegada') as HTMLInputElement)?.value;
      const salidaVal = (document.getElementById('salida') as HTMLInputElement)?.value;
      const personasVal = (document.getElementById('personas') as HTMLSelectElement)?.value;
      const nombreVal = (document.getElementById('nombre') as HTMLInputElement)?.value;
      if (!llegadaVal || !salidaVal || !personasVal || !nombreVal) {
        alert('Por favor completa todos los campos');
        return;
      }
      function formatearFecha(fecha: string) {
        const f = new Date(fecha);
        return f.toLocaleDateString('es-ES', {
          day: '2-digit',
          month: 'long',
          year: 'numeric'
        });
      }
      const llegadaFormateada = formatearFecha(llegadaVal);
      const salidaFormateada = formatearFecha(salidaVal);
      const params = new URLSearchParams(window.location.search);
      const utm_source = params.get('utm_source') || '';
      const utm_campaign = params.get('utm_campaign') || '';
      const utm_content = params.get('utm_content') || '';
      const sheetURL = 'https://script.google.com/macros/s/AKfycbxDzb067uONmydeX0w4xRVqBMajI5wXS58RgqU_vA_KHnTPRauo4Kp78ztxygBDMYKo/exec';
      const query = `?nombre=${encodeURIComponent(nombreVal)}&personas=${personasVal}&llegada=${encodeURIComponent(llegadaFormateada)}&salida=${encodeURIComponent(salidaFormateada)}&utm_source=${utm_source}&utm_campaign=${utm_campaign}&utm_content=${utm_content}`;
      // 🔥 ENVÍA A GOOGLE SHEETS Y LUEGO ABRE WHATSAPP
      fetch(sheetURL + query).finally(() => {
        const mensaje = `Hola, quiero confirmar mi reserva en Hacienda El Rosario:\nNombre: ${nombreVal}\nHuéspedes: ${personasVal}\nLlegada: ${llegadaFormateada}\nSalida: ${salidaFormateada}`;
        const url = 'https://wa.me/584246782227?text=' + encodeURIComponent(mensaje);
        window.open(url, '_blank');
      });
    };
    return () => {
      delete (window as any).enviarWhatsApp;
    };
  }, []);
  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };
  return <AnimatePresence data-id="element-1">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-4" onClick={handleBackdropClick} data-id="element-2">
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.97
      }} transition={{
        duration: 0.35,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} className="relative w-full max-w-[400px] bg-white rounded-lg px-8 py-10 md:px-10 md:py-12 text-center" data-id="element-3">
            {/* Close */}
            <button onClick={onClose} className="absolute top-4 right-5 text-[#2C2420]/60 hover:text-[#2C2420] transition-colors focus:outline-none" aria-label="Cerrar" data-id="element-4">
              <XIcon size={18} strokeWidth={1.5} data-id="element-5" />
            </button>

            <h2 className="font-serif text-xl md:text-2xl text-[#2C2420] mb-2" data-id="element-6">
              Verifica disponibilidad
            </h2>
            <p className="font-sans text-sm text-[#2C2420]/50 mb-8" data-id="element-7">
              Completa estos datos para continuar
            </p>

            <div className="flex flex-col gap-4 mb-6" data-id="element-8">
              <div className="text-left" data-id="element-9">
                <label className="block font-sans text-[11px] uppercase tracking-widest text-[#2C2420]/50 mb-2" data-id="element-10">
                  Fecha de llegada
                </label>
                <input id="llegada" type="date" value={llegada} onChange={e => setLlegada(e.target.value)} onClick={e => (e.currentTarget as HTMLInputElement).showPicker()} className="w-full bg-transparent border-b border-[#2C2420]/20 pb-2 pt-1 text-[15px] font-light text-[#2C2420] focus:outline-none focus:border-[#2C2420]/50 transition-colors font-[Inter,_sans-serif]" data-id="element-11" />
              </div>

              <div className="text-left" data-id="element-12">
                <label className="block font-sans text-[11px] uppercase tracking-widest text-[#2C2420]/50 mb-2" data-id="element-13">
                  Fecha de salida
                </label>
                <input id="salida" type="date" value={salida} onChange={e => setSalida(e.target.value)} onClick={e => (e.currentTarget as HTMLInputElement).showPicker()} className="w-full bg-transparent border-b border-[#2C2420]/20 pb-2 pt-1 text-[15px] font-light text-[#2C2420] focus:outline-none focus:border-[#2C2420]/50 transition-colors font-[Inter,_sans-serif]" data-id="element-14" />
              </div>

              <div className="text-left" data-id="element-15">
                <label className="block font-sans text-[11px] uppercase tracking-widest text-[#2C2420]/50 mb-2" data-id="element-16">
                  Huéspedes
                </label>
                <select id="personas" value={personas} onChange={e => setPersonas(e.target.value)} className="w-full bg-transparent border-b border-[#2C2420]/20 pb-2 pt-1 text-[15px] font-light text-[#2C2420] focus:outline-none focus:border-[#2C2420]/50 transition-colors font-[Inter,_sans-serif] appearance-none" data-id="element-17">
                  <option value="" data-id="element-18">Seleccionar</option>
                  <option value="2" data-id="element-19">2</option>
                  <option value="4" data-id="element-20">4</option>
                  <option value="6" data-id="element-21">6</option>
                </select>
              </div>

              <div className="text-left" data-id="element-22">
                <label className="block font-sans text-[11px] uppercase tracking-widest text-[#2C2420]/50 mb-2" data-id="element-23">
                  Nombre completo
                </label>
                <input id="nombre" type="text" value={nombre} onChange={e => setNombre(e.target.value)} placeholder="Tu nombre" className="w-full bg-transparent border-b border-[#2C2420]/20 pb-2 pt-1 text-[15px] font-light text-[#2C2420] placeholder:text-[#2C2420]/30 focus:outline-none focus:border-[#2C2420]/50 transition-colors font-[Inter,_sans-serif]" data-id="element-24" />
              </div>
            </div>

            {error && <p className="text-red-500 text-xs mb-4 font-sans" data-id="element-25">{error}</p>}

            <a href="#" onClick={e => {
          e.preventDefault();
          (window as any).enviarWhatsApp();
        }} style={{
          fontFamily: 'serif',
          fontSize: '16px',
          textDecoration: 'none',
          borderBottom: '1px solid #2C2420',
          paddingBottom: '3px',
          cursor: 'pointer',
          color: '#2C2420'
        }} data-id="element-26">
              Completar registro →
            </a>

            <p className="font-sans mt-4 text-[#080808] text-[14px] font-[600]" data-id="element-27">
              Te responderemos con disponibilidad en minutos Estadías desde $120
              por noche · desayuno incluido
            </p>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}